module.exports = __webpack_public_path__ + "img/reserved_5.0673cd35.jpg";